import { render, staticRenderFns } from "./SidebarSubnavigation.vue?vue&type=template&id=43c16dd6"
import script from "./SidebarSubnavigation.vue?vue&type=script&lang=js"
export * from "./SidebarSubnavigation.vue?vue&type=script&lang=js"
import style0 from "./SidebarSubnavigation.vue?vue&type=style&index=0&id=43c16dd6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports